import { useTranslatable } from 'src/hooks/locale/utils'
import SuspenseWrapper from 'src/views/includes/SuspenseWrapper'

export default function LecturerCourseScoreStatistics(): JSX.Element | null {
  const t = useTranslatable()

  return (
    <SuspenseWrapper title={t('subPage:score_statistics')}>
      <PageContent />
    </SuspenseWrapper>
  )
}

function PageContent(): JSX.Element {
  return <>score statistics</>
}
